import AddEditLearnMoreScreen from "../../screens/AddEditLearnMoreScreen";
import { connect } from "react-redux";
import {
  editLearnMore,
  addLearnMore,
  deleteLearnMore,
} from "../actions/rightsActions";

const mapDispatchToProps = (dispatch) => ({
  editLearnMore: (newLearnMore, oldLearnmore, navigateFunction) => {
    dispatch(editLearnMore(newLearnMore, oldLearnmore, navigateFunction));
  },
  addLearnMore: (newLearnMore, navigateFunction) => {
    dispatch(addLearnMore(newLearnMore, navigateFunction));
  },
  deleteLearnMore: (learnMore, parentSubright, navigateFunction) => {
    dispatch(deleteLearnMore(learnMore, parentSubright, navigateFunction));
  },
});

const mapStateToProps = (state) => ({
  selectedSubright: state.rights.selectedSubright,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEditLearnMoreScreen);
